export const OTP_TYPE_SIGN_IN = 'sign-in' as const
export const AUTH_HEADER_SCHEME = 'Bearer' as const

export const AUTH_TOKEN_KEY = 'kanguro_auth_token'
export const REFRESH_TOKEN_KEY = 'kanguro_refresh_token'
export const USER_PROFILE_KEY = 'kanguro_user_profile'

export const OTP_EMAIL_KEY = 'kanguro_otp_email'

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const OTP_EXPIRED_REGEX = /expir/i
export const INPUT_TYPE_EMAIL = 'email' as const
